import Image from 'next/image';
import Link from 'next/link';
import { Section } from '../section/section.comp';
import { StyledDiv } from './platforms.styles';

import joomlaLogo from '../../../public/assets/platforms/joomla.svg';
import modxLogo from '../../../public/assets/platforms/modx.svg';
import nopcommerceLogo from '../../../public/assets/platforms/nopcommerce.png';
import opencartLogo from '../../../public/assets/platforms/opencart.png';
import prestashopLogo from '../../../public/assets/platforms/prestashop.svg';
import shift4shopLogo from '../../../public/assets/platforms/shift4shop.svg';
import shopifyLogo from '../../../public/assets/platforms/shopify.svg';
import webflowLogo from '../../../public/assets/platforms/webflow.svg';
import websitex5Logo from '../../../public/assets/platforms/websitex5.svg';
import weeblyLogo from '../../../public/assets/platforms/weebly.svg';
import wixLogo from '../../../public/assets/platforms/wix.svg';
import wordpressLogo from '../../../public/assets/platforms/wordpress.svg';

export const Platforms = () => {
	const platformList = [
		{
			title: 'WordPress',
			slug: 'wordpress',
			logoPath: wordpressLogo,
		},
		{ title: 'Wix', slug: 'wix', logoPath: wixLogo },
		{
			title: 'Shopify',
			slug: 'shopify',
			logoPath: shopifyLogo,
		},
		{
			title: 'Weebly',
			slug: 'weebly',
			logoPath: weeblyLogo,
		},
		{
			title: 'Webflow',
			slug: 'webflow',
			logoPath: webflowLogo,
		},
		{
			title: 'Joomla',
			slug: 'joomla',
			logoPath: joomlaLogo,
		},
		{
			title: 'PrestaShop',
			slug: 'prestashop',
			logoPath: prestashopLogo,
		},
		{
			title: 'Shift4Shop',
			slug: 'shift4shop',
			logoPath: shift4shopLogo,
		},
		{
			title: 'WebsiteX5',
			slug: 'websitex5',
			logoPath: websitex5Logo,
		},
		{ title: 'MODX', slug: 'modx', logoPath: modxLogo },
		{
			title: 'Opencart',
			slug: 'opencart',
			logoPath: opencartLogo,
		},
		{
			title: 'NopCommerce',
			slug: 'nopcommerce',
			logoPath: nopcommerceLogo,
		},
	];

	return (
		<Section>
			<StyledDiv>
				<p>Discover Apps By Platform</p>
				<h2>Discover the best apps for your website</h2>
				<div className="platforms-container">
					{platformList.map((platform) => (
						<Link
							title={`Apps for ${platform.title}`}
							href={`/${platform.slug}`}
							key={platform.title}
							className="platform-card"
						>
							<div className="img-wrapper">
								<Image src={platform.logoPath} alt={platform.title} fill />
							</div>
						</Link>
					))}
				</div>
			</StyledDiv>
		</Section>
	);
};
